(function () {
  function moveGorgiasBeforeReactAttaches() {
    var targetLocation = document.querySelector('.header__column.header__column--center');

    if (!targetLocation) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (
            node.nodeType === 1 &&
            (node.id === 'gorgias-chat-container' || node.getAttribute('data-gorgias-chat-app'))
          ) {
            targetLocation.insertAdjacentElement('afterend', node);
            observer.disconnect();
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  function addOutlineForChatButton() {
    var intervalId = setInterval(function () {
      var iframe = document.querySelector('iframe#chat-button');
      if (!iframe) return;

      var iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
      if (!iframeDoc) return;

      var chatButton = iframeDoc.querySelector('#gorgias-chat-messenger-button');
      if (!chatButton) return;

      var style = iframeDoc.createElement('style');
      style.textContent =
        '#gorgias-chat-messenger-button:focus-visible { outline: 2px solid red; outline-offset: 1px; }';
      iframeDoc.head.appendChild(style);

      clearInterval(intervalId);
    }, 300);

    setTimeout(function () {
      clearInterval(intervalId);
    }, 10000);
  }

  function removeTabIndexFromChatCampaigns() {
    var intervalId = setInterval(function () {
      var chatCampaigns = document.querySelector('#chat-campaigns');
      if (chatCampaigns) {
        chatCampaigns.setAttribute('tabindex', '-1');
        clearInterval(intervalId);
      }
    }, 300);

    setTimeout(function () {
      clearInterval(intervalId);
    }, 10000);
  }

  function setTabIndexOnFloatingWidget() {
    var selector = '#mount-floating-engagement-widget, mount-floating-engagement-widget';

    function apply() {
      var widget = document.querySelector(selector);
      if (!widget) return false;
      if (widget.getAttribute('tabindex') !== '-1') {
        widget.setAttribute('tabindex', '-1');
      }
      return true;
    }

    // Apply as soon as the third-party app injects the widget.
    var intervalId = setInterval(function () {
      if (apply()) clearInterval(intervalId);
    }, 300);

    setTimeout(function () {
      clearInterval(intervalId);
    }, 10000);

    // Keep it out of the tab order even if the app re-mounts and drops the attribute.
    var observer = new MutationObserver(apply);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  moveGorgiasBeforeReactAttaches();
  addOutlineForChatButton();
  removeTabIndexFromChatCampaigns();
  setTabIndexOnFloatingWidget();
})();
